import { render, staticRenderFns } from "./CardStyle5.vue?vue&type=template&id=4e9954f2&scoped=true&"
import script from "./CardStyle5.vue?vue&type=script&lang=js&"
export * from "./CardStyle5.vue?vue&type=script&lang=js&"
import style0 from "./CardStyle5.vue?vue&type=style&index=0&id=4e9954f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9954f2",
  null
  
)

export default component.exports